/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import styled from "styled-components";
import {
  Grid,
  TextField,
  Box,
  Link,
  Button,
  Dialog,
  Slide,
  Typography,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import pr from "../lib/pr";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import DashboardIcon from "@material-ui/icons/Dashboard";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Divider from "@mui/material/Divider";
import Layout from "./Layout";
import { loginState, configState } from "../lib/State";

function Home() {
  const history = useHistory();
  const [login, setLogin] = useState(loginState);
  const [loaded, setLoaded] = useState(false);  
  const token = localStorage.getItem("token");

  const token_login = async () => {
    const token = localStorage.getItem("token");    
    console.log(token);
    
    const cid = configState.cid;
    let result = await axios.post(configState.api + "/hr/token_login", {
      cid: cid,
      token: token,
    });    
    get_session();    
  };

  // 세션 로그인
  const get_session = async () => {
    const token = localStorage.getItem("token");
    const cid = configState.cid;
    let result = await axios.post(configState.api + "/hr/get_session",{
      cid:cid,
      token:token
    });
    setLogin({ ccid: result.data.ccid, level: result.data.level });

    if (result.data.level !== "manager") {
      window.location.href = "/";
    } else {
      setLoaded(true);
    }
  };

  const onDown = () => {
    window.location.href =
      "http://smartfitkorea.com/upload/docircuit/docircuit_hr.zip";
  };

  useEffect(()=>{
    token_login();
  },[]);

  return (
    <>
      {!loaded ? (
        <Loading />
      ) : (
        <Layout login={login}>
          <h3>대시보드</h3>
          <div
            css={css`
              padding-top: 10px;
            `}
          ></div>
          {/* <>
          <div>센타명 : 두써킷 센텀시티점</div>
          <div>연락처 : 010-000-0000</div>
          <div>담당자 : 홍길동</div>
          <div>가입일 : 2021-01-01</div>
          <div>이용기간 : 2021-01-01 ~ 2022-05-05</div>
          </> */}
          <div
            css={css`
              margin-top: 30px;
            `}
          >
            <Box>
              <a href="http://smartfitkorea.com/upload/docircuit/docircuit_hr.zip" target="_blank">윈도우용 RC900/RC905 심박공유기 프로그램 다운로드</a>            
            </Box>
          </div>
        </Layout>
      )}
    </>
  );
}

export default Home;
